//
// HeaderLocation.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var HeaderLocation = {
    TOP:0,
    BOTTOM:1,
    LEFT:2,
    RIGHT:3
};
export default HeaderLocation;
